import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../api/client';
import { useStore } from '../stores/store';
import { H2, Muted } from '../components/ui';

const Form = styled.form`
  background: ${({ theme }) => theme.colors.surface};
  border: 1.5px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.radius};
  padding: 18px;
  margin-top: 8px;

  input {
    width: 100%;
    box-sizing: border-box;
    font-size: 1.1rem;
    padding: 12px;
    border-radius: 10px;
    border: 1.5px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.text};
    margin: 10px 0;
    letter-spacing: 2px;
  }
  button {
    width: 100%;
    border: none;
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.accentText};
    border-radius: 10px;
    padding: 13px;
    font-size: 1.05rem;
    font-weight: 700;
  }
  .err { color: ${({ theme }) => theme.colors.danger}; font-size: 0.9rem; margin-top: 8px; }
`;

export function Acceso() {
  const navigate = useNavigate();
  const setAdminKey = useStore((s) => s.setAdminKey);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const c = code.trim();
    if (!c) return;
    setLoading(true);
    setError('');
    try {
      await api.trackSummary(c); // si responde, el código es válido (lo valida el backend)
      setAdminKey(c);
      navigate('/uso', { replace: true });
    } catch {
      setError('Código incorrecto.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <H2>Acceso restringido</H2>
      <Muted>Ingresá el código para habilitar las estadísticas de uso en este dispositivo.</Muted>
      <Form onSubmit={submit}>
        <input
          type="password"
          inputMode="text"
          autoFocus
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Código de acceso"
          aria-label="Código de acceso"
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Verificando…' : 'Ingresar'}
        </button>
        {error && <div className="err">{error}</div>}
      </Form>
    </>
  );
}
